import React, { memo, useCallback } from 'react'

import styled from '@emotion/styled'

import { Button, Title, Text, Box } from '@surglogs-app/ui'

import { ErrorScreenContent, ErrorScreenContentHeadline } from '../components'
import { ErrorScreenBackButton } from '../components/ErrorScreenBackButton'
import { useTranslation } from '../services'

const ButtonsContainer = styled(Box)`
  padding-top: 15px;
  & button {
    margin-right: 10px;
  }
`

const RefreshPageButton = memo(() => {
  const { t } = useTranslation()

  const onClick = useCallback(() => window.location.reload(), [])

  return <Button {...{ onClick }}>{t('refreshButtonLabel')}</Button>
})

export const UnknownErrorScreen = ({
  isAuthorized,
}: {
  isAuthorized: () => boolean
}) => {
  const { t } = useTranslation()

  return (
    <ErrorScreenContent>
      <ErrorScreenContentHeadline>{t('code')}</ErrorScreenContentHeadline>
      <Title>{t('title')}</Title>
      <Text {...{ paragraph: true, mb: 'md' }}>{t('body')}</Text>
      <ButtonsContainer>
        <RefreshPageButton />
        <ErrorScreenBackButton {...{ isAuthorized }} />
      </ButtonsContainer>
    </ErrorScreenContent>
  )
}
